import { queryOptions } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

function getCompanyUsersQuery(opts: RequestOpts = {}) {
  const queryKey = ['getCompanyUsers'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return api.getIdentityUsers({
        ...opts,
        signal,
      });
    },
    retry: true,
    staleTime: ms('5m'),
    gcTime: ms('10m'),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchCompanyUsersQuery(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getCompanyUsersQuery(opts));
}
